var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 718,
    height: 364,
    viewBox: "0 0 718 364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.m{fill:#fff;}.b{clip-path:url(#a);}.c{fill:#daeaee;}.d{fill:#1371b1;}.e{fill:#a9cdd3;stroke:#fff;stroke-width:2px;}.e,.f{stroke-miterlimit:10;}.f,.g{fill:none;}.f{stroke:#9cb3b7;}.g{stroke:#557f84;stroke-linejoin:round;stroke-dasharray:12 20;}.h{fill:#eeb38c;}.i{fill:#1b384c;}.i,.j,.m{fill-rule:evenodd;}.j{fill:url(#b);}.k{fill:#0e2a30;}.l{fill:#12406f;}.m{opacity:0.12;}.n{fill:#f9f9f9;}.o{fill:#b0b0b0;}.p{fill:#0d3359;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 718,
    height: 364,
    transform: "translate(4173.039 6461.853)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54a0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-4173.039 -6461.853)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M57.627,1254.51H734.588s-43.643-61.035-102.053-41.018-160.377,31.5-186.343-40.034S371,1018.574,277.484,1041.544,224,1201.351,163.289,1173.458,35.641,1184.287,23.5,1254.51Z",
    transform: "translate(4162.578 5572.537)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4345.998 6496.528)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-691.9,238.666l-7.4-3.193a4.529,4.529,0,0,1-2.708-3.538,4.529,4.529,0,0,1,1.6-4.158l6.2-5.15a.2.2,0,0,0,.054-.236l-9.4-20.575a.2.2,0,0,0-.213-.114l-7.955,1.316a4.582,4.582,0,0,1-4.428-1.811,4.507,4.507,0,0,1-.663-4.065l2.435-7.686a.2.2,0,0,0-.082-.228L-733.481,177a.2.2,0,0,0-.241.02l-5.98,5.408a4.47,4.47,0,0,1-3.042,1.181,4.525,4.525,0,0,1-4.419-3.371l-2.107-7.783a.2.2,0,0,0-.192-.146h-22.619a.2.2,0,0,0-.192.146l-2.107,7.783a4.525,4.525,0,0,1-4.418,3.371,4.469,4.469,0,0,1-3.042-1.181l-5.98-5.408a.2.2,0,0,0-.241-.02l-19.029,12.229a.2.2,0,0,0-.082.228l2.435,7.686a4.509,4.509,0,0,1-.663,4.065,4.576,4.576,0,0,1-4.428,1.81l-7.955-1.316a.2.2,0,0,0-.213.114l-9.4,20.575a.2.2,0,0,0,.054.236l6.2,5.15a4.529,4.529,0,0,1,1.6,4.158,4.529,4.529,0,0,1-2.708,3.538l-7.4,3.193a.2.2,0,0,0-.118.211l3.219,22.389a.2.2,0,0,0,.172.169l8,.978a4.528,4.528,0,0,1,3.594,2.632,4.529,4.529,0,0,1-.365,4.441l-4.5,6.689a.2.2,0,0,0,.015.241l14.813,17.094a.2.2,0,0,0,.237.049l7.262-3.5a4.529,4.529,0,0,1,1.982-.46,4.612,4.612,0,0,1,3.271,1.386,4.507,4.507,0,0,1,1.288,3.277l-.171,8.061a.2.2,0,0,0,.143.195l21.7,6.373a.2.2,0,0,0,.226-.087l4.214-6.874a4.53,4.53,0,0,1,3.887-2.177,4.528,4.528,0,0,1,3.887,2.177l4.215,6.874a.2.2,0,0,0,.169.095.207.207,0,0,0,.056-.008l21.7-6.373a.2.2,0,0,0,.143-.195l-.171-8.061a4.507,4.507,0,0,1,1.288-3.277,4.612,4.612,0,0,1,3.271-1.386,4.529,4.529,0,0,1,1.981.46l7.262,3.5a.2.2,0,0,0,.237-.049l14.813-17.094a.2.2,0,0,0,.015-.241l-4.5-6.689a4.529,4.529,0,0,1-.365-4.441,4.529,4.529,0,0,1,3.594-2.632l8-.978a.2.2,0,0,0,.173-.169l3.219-22.389A.2.2,0,0,0-691.9,238.666Zm-68.874,34.549A32.613,32.613,0,0,1-793.384,240.6a32.613,32.613,0,0,1,32.613-32.613A32.613,32.613,0,0,1-728.158,240.6,32.613,32.613,0,0,1-760.772,273.215Z",
    transform: "translate(829.765 -172.308)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M205,1427.734H372.846v-132c-23.311,12.02-40.706,26.9-44.769,42.639-13.106,50.758-35.134,63.112-66.964,49.986S205,1427.734,205,1427.734Z",
    transform: "translate(4040.636 5399.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M372.846,1427.734H205v-132c23.311,12.02,40.706,26.9,44.769,42.64,13.106,50.758,35.134,63.112,66.964,49.987S372.846,1427.734,372.846,1427.734Z",
    transform: "translate(4273.177 5399.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1444.342,1389.617c12.942,0,22.728.759,19.427-4.927s-7.748.682-9.39-3.411-6.281-10.916-13.969-5.231-.914,10.006-8.28,7.05-8.026,5.988-.305,6.519A77.46,77.46,0,0,0,1444.342,1389.617Z",
    transform: "translate(3411.833 5126.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M766.14,444.151c19.618,0,34.45,1.149,29.447-7.469s-11.744,1.034-14.234-5.171-9.52-16.546-21.172-7.928S758.8,438.751,747.63,434.27s-12.165,9.077-.463,9.881A117.468,117.468,0,0,0,766.14,444.151Z",
    transform: "translate(3970.802 6139.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M602.824,382.812c15.88,0,27.887.93,23.836-6.046s-9.507.837-11.522-4.186-7.706-13.394-17.138-6.418-1.121,12.278-10.16,8.65-9.847,7.347-.374,8A95.076,95.076,0,0,0,602.824,382.812Z",
    transform: "translate(3605.244 6161.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1387.706,1451.979c8.616,0,15.13.5,12.933-3.28s-5.158.454-6.251-2.271-4.181-7.267-9.3-3.482-.608,6.661-5.512,4.693-5.343,3.986-.2,4.34A51.576,51.576,0,0,0,1387.706,1451.979Z",
    transform: "translate(3254.091 5301.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1234.5,346.414s37.232-18.861,55.848,12c16.428,27.235.734,50.7-10.533,56.828",
    transform: "translate(3286.029 6127.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M93,1396.864s40.69-46.925,96.146-22.642",
    transform: "translate(4115.884 5351.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1462,1527.334s31.5,27.236,104.022,5.906,102.381-12.469,132.9,25.267",
    transform: "translate(3196.114 5247.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M560.761,503s-37.729,48.673-14.688,93.313",
    transform: "translate(3791.052 6002.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M19.174,0A19.174,19.174,0,1,1,0,19.174,19.174,19.174,0,0,1,19.174,0Z",
    transform: "translate(4396.584 6545.988)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4369.223 6495.223)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M555.772,647.784c-6.156-10.51-23.4-12.785-14.3-19.442-.257.187,3.485-3.1,4.394-4.124.385-.434.661-.73.888-.966.132-.25.29-.543.52-.948.384-.67,1.841-4.4,1.391-2.841a33.432,33.432,0,0,0,.993-3.69c.112-.634.194-1.081.253-1.371.065-.725.144-1.447.189-2.172.105-1.958.2-3.911.22-5.871.05-4.3.014-8.609.006-12.914a19.432,19.432,0,0,1,4.813-13.422c-5.321-3.431-11.092-3.886-13.172-.938l-.74,1.05-3.246,4.6-.19.269-2.428-1.712,3.216-4.558,3.267-4.633,2.632-3.731c2.184-3.1-.521-8.758-6.023-12.641s-11.746-4.528-13.93-1.433l-2.633,3.732-3.268,4.631-3.215,4.559-2.427-1.713,14.684-20.817-.02-.015c.117-.165.246-.305.364-.474l19.308-27.373c3.533-5.009,1.922-12.218-3.579-16.1s-12.838-2.98-16.371,2.027l-19.308,27.373c-.119.168-.212.334-.315.51l-.031-.021-42.51,60.266-11.221,21.99-3.15-60.846c1.7-7.17,2.763-14.123-3.166-18.3a13.132,13.132,0,0,0-18.3,3.165L425.9,589.849s-5.875,13.916-1.792,35.672l9.565,19.244c.416,110.924,6.836,72.92.416,81.844l81.12,9.184c2.3-9.184.466-54.048.466-54.048,3.279-1.044,12.51-3.831,17.163-6.281,2.219-1.167,5.876-3.506,10.306-8.967C551.18,655.5,557.789,651.228,555.772,647.784Z",
    transform: "translate(-396.43 -437.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M671.856,466.211c-5.512-3.887-12.839-2.98-16.372,2.027l-19.308,27.373c-.119.168-.212.334-.315.51l-.031-.021-42.51,60.268-.183-.129c.039.241.075.481.113.721,1.436,8.9,2.081,19.246,5.208,27.859l.031.031c.04.019.078.038.12.06.054-.377.559.077.839.444.056.031.117.063.166.091.162.048.3.089.5.15q1.763.575,3.556,1.039c.086.022.173.038.259.06.007-.007.016-.023.022-.029,1.309-1.789,2.61-3.581,3.884-5.4C615.751,570,623.062,558.345,630,546.457a19.481,19.481,0,0,1,14.172-9.8,22.567,22.567,0,0,1-.032-4.825l-.616.875L641.1,530.99l6.023-8.537a19.479,19.479,0,0,1,2.1-2.982l6.56-9.3-.021-.014c.117-.165.246-.306.365-.475l19.309-27.373C678.968,477.3,677.357,470.093,671.856,466.211Z",
    transform: "translate(-484.744 -418.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M595.686,581.624a6.514,6.514,0,0,1-6.556,6.436H487.111a6.516,6.516,0,0,1-6.557-6.436V376.776a6.517,6.517,0,0,1,6.557-6.437H589.13a6.514,6.514,0,0,1,6.556,6.437Z",
    transform: "translate(-426.419 -370.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M590.868,420.219H491.52v23.22l-.008-.007v6.254l.008.007v17.255h0v20.894h-.005v5.165h0l0,51.847h0v4.7h0v23.964h0v6.254h0v15.6H596.083V420.219Z",
    transform: "translate(-432.095 -396.18)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 258.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 130.438,
    height: 141.617,
    transform: "translate(7.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M597.644,937.836a5.943,5.943,0,1,0-5.6-6.272A5.949,5.949,0,0,0,597.644,937.836Z",
    transform: "translate(-484.171 -916.414)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 143.947,
    height: 112.023,
    transform: "translate(0 29.594)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M599.653,796.088a4.541,4.541,0,1,1-4.541-4.54A4.541,4.541,0,0,1,599.653,796.088Z",
    transform: "translate(-482.177 -587.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M706.2,698.381a9.072,9.072,0,0,1-6.243,11.2l-21.848,5.79a9.076,9.076,0,0,1-10.972-6.64h0a9.073,9.073,0,0,1,6.243-11.2l21.848-5.791a9.073,9.073,0,0,1,10.972,6.638Z",
    transform: "translate(-522.912 -536.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M515.377,783.549c.4-1.631.755-3.263,1.034-4.885-.293-.877.6-18.258-19.675-32.463-9.387-6.574-20.451-5.1-25.521-4.641v41.989Z",
    transform: "translate(-421.581 -562.409)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.172 61.335)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M559.658,497.605l37.531,30.614-37.674,32.311L522.129,528.22Z",
    transform: "translate(-522.129 -497.605)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 64.741,
    height: 3.459,
    transform: "translate(5.052 6.844)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 64.741,
    height: 62.374,
    transform: "translate(5.052 10.303)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.626 27.547)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 24.253,
    height: 1.472
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 53.591,
    height: 1.472,
    transform: "translate(0 6.021)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 53.591,
    height: 1.472,
    transform: "translate(0 9.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 53.591,
    height: 1.472,
    transform: "translate(0 12.713)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 53.591,
    height: 1.472,
    transform: "translate(0 16.057)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.626 46.956)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 53.591,
    height: 1.471
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 53.591,
    height: 1.473,
    transform: "translate(0 3.345)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 53.591,
    height: 1.47,
    transform: "translate(0 6.691)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 53.591,
    height: 1.472,
    transform: "translate(0 10.036)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M601.512,561.128V607.61a4.1,4.1,0,0,1-4.089,4.088H530.541C527.961,611.7,601.512,561.128,601.512,561.128Z",
    transform: "translate(-526.452 -530.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M522.129,561.128V607.61a4.1,4.1,0,0,0,4.088,4.088H593.1C595.68,611.7,522.129,561.128,522.129,561.128Z",
    transform: "translate(-522.129 -530.514)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M698.44,594.013c2.629,5.575.729,12-4.24,14.338l-22.843,10.768c-4.972,2.343-11.132-.279-13.758-5.855h0c-2.628-5.576-.731-12,4.238-14.338l22.843-10.768c4.971-2.342,11.133.279,13.76,5.855Z",
    transform: "translate(-517.525 -482.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M705.049,653.063c1.265,5.124-1.583,10.232-6.358,11.411l-21.941,5.415c-4.776,1.178-9.672-2.02-10.934-7.144h0c-1.264-5.124,1.582-10.232,6.354-11.41l21.943-5.414c4.776-1.179,9.675,2.02,10.937,7.143Z",
    transform: "translate(-522.24 -512.979)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4494.519 6461.744)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 33.025,
    cy: 33.025,
    r: 33.025,
    transform: "translate(0 46.705) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.078 32.008)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.129 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M784.765,124.863c0-.006-.006-.008-.006-.014s0-.008-.005-.011l-.006-.006c0-.006,0-.008-.005-.014a0,0,0,0,1,0,0s0-.006-.006-.008a.323.323,0,0,0-.048-.059.063.063,0,0,0-.019-.019.431.431,0,0,0-.154-.092l-.031-.008a.423.423,0,0,0-.221.006l-.042.014s0,0-.006,0l-.047.025a.454.454,0,0,0-.047.031l-2.806,1.692-28.228,17.05-.207.126a.419.419,0,0,0-.17.522l.056.134,3.286,7.795a.454.454,0,0,0,.1.176.41.41,0,0,0,.036.033.379.379,0,0,0,.07.048c.005,0,.008.006.014.006a.36.36,0,0,0,.047.02.345.345,0,0,0,.05.014.428.428,0,0,0,.084.008.418.418,0,0,0,.288-.115l.179-.17,3.571-3.437.346-.332.3-.29-.517-.237-.3-.139h0l-.645.622h0l-2.608,2.51-.464.447-.329-.784-2.652-6.3L779.1,128.716l.009-.006,2.286-1.379-3.831,3.685,5.785-4.618-.154.36,1.449-1.393a.314.314,0,0,0,.031-.031.336.336,0,0,0,.061-.078.142.142,0,0,0,.025-.045c0-.006.006-.008.008-.014a.324.324,0,0,0,.025-.09.347.347,0,0,0,.008-.075A.408.408,0,0,0,784.765,124.863Z",
    transform: "translate(-752.676 -124.617)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.33 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M799.571,124.863c0-.006-.006-.008-.006-.014s0-.008-.005-.011l-.005-.006s0-.006-.006-.008v-.006a0,0,0,0,1,0,0s0-.006-.006-.008a.331.331,0,0,0-.047-.059.064.064,0,0,0-.019-.019.43.43,0,0,0-.154-.092l-.031-.008a.423.423,0,0,0-.22.006l-.042.014s0,0-.006,0l-.047.025a.467.467,0,0,0-.047.031l-5.014,4-.009.006-22.042,17.6a.2.2,0,0,0-.036.031.221.221,0,0,0-.045.045.143.143,0,0,0-.02.025.47.47,0,0,0-.036.061.456.456,0,0,0-.031.086v.006a.258.258,0,0,0-.009.047.553.553,0,0,0,0,.092.412.412,0,0,0,.24.33l.5.234,2.052.955h0l.033.017.782.36.036.019,11.5,5.344a.425.425,0,0,0,.176.039.41.41,0,0,0,.151-.028.423.423,0,0,0,.235-.226L799.574,125.2a.333.333,0,0,0,.025-.09.351.351,0,0,0,.009-.075A.411.411,0,0,0,799.571,124.863ZM786.8,153.03l-10.849-5.045-.516-.237-.3-.139h0l-2.236-1.042,19.476-15.551,5.785-4.618-.154.36Z",
    transform: "translate(-771.684 -124.617)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M713.879,144.347a.416.416,0,0,1-.2-.052l-11.129-6.089a.419.419,0,0,1,.08-.768l42.416-12.809a.419.419,0,0,1,.338.76l-31.287,18.9A.417.417,0,0,1,713.879,144.347Zm-10.052-6.4,10.041,5.494L742.1,126.393Z",
    transform: "translate(-702.332 -124.611)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.88a4f2d264a2d4306e189d6c976cba90.svg";
export { ForwardRef as ReactComponent };